import React, { Fragment, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { getSingleCustomer } from 'api/subscriptions';
import ShortenId from 'components/Atom/ShortenId';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Breadcrumbs } from 'components/Atom/breadcumbs';
import { ResetButton } from 'components/Atom/Button';
import LoadingSkeleton from 'components/Skeleton';
import { Empty } from 'antd';
import { TIMEZONES } from 'utils/constant';
import { formatInTimeZone } from 'date-fns-tz';
import { hiddenCardNumber } from 'utils/helper';
import StatusTag from 'components/Atom/StatusTag';

export const ViewCustomerDetails = () => {
  const location = useLocation();
  const store = useSelector((state) => state.company.store);
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchCustomerData = async () => {
    const response = await getSingleCustomer(location?.state?.record?.store_id || store?._id, id || location?.state?.record?._id);
    return response?.data?.data || null;
  };
  const {
    data: record,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`customer_${id || location?.state?.record?._id}`, fetchCustomerData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store]);

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Customer',
        href: '/subscriptions/customer',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };

  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const generalInformation = [
    { label: 'Customer ID', value: <ShortenId value={record?._id} /> },
    { label: 'First Name', value: record?.first_name },
    { label: 'Last Name', value: record?.last_name },
    { label: 'Email', value: record?.email },
    { label: 'Phone', value: record?.phone },
    /*  { label: 'Shipping Address', value: record?.shipping_address || 'N/A' }, */
    { label: 'Creation Time', value: record?.createdAt ? formatInTimeZone(record?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
    { label: 'Last Update Time', value: record?.updatedAt ? formatInTimeZone(record?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
  ];

  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums'>
          <div
            className='back-button'
            onClick={() =>
              navigate('/subscriptions/customer', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mb-0 mt-4'>Customer Detail</div>
      </div>

      <div className='subscription-details logs-details'>
        {isLoading ? (
          <LoadingSkeleton />
        ) : !record ? (
          store?.isSelected ? (
            <div className='empty-custom-style'>
              <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className='empty-custom-style'>
              <Empty description={'Select store from the drop-down menu above'} />
            </div>
          )
        ) : (
          <>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Customer Detail</h3>
              </div>
              <div className='detail-card'>
                {generalInformation?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>
            {record?.tokens?.length > 0 && (
              <div className='details-section '>
                <div className='heading-section'>
                  <h3>Payment Methods</h3>
                </div>
                {record?.tokens?.length > 0 &&
                  record?.tokens?.map((token) => (
                    <div className='detail-card'>
                      <Fragment key={token?._id}>
                        <div className='detail-value'>
                          <h2>Payment Token</h2>
                          <span>
                            <ShortenId value={token?._id} />
                            <span className='default-tag'>{token?._id === record?.default_payment_method?._id ? <StatusTag tag={'Default'} color={'succeeded'} /> : ''}</span>
                          </span>
                        </div>
                        <div className='detail-value'>
                          <h2>Card Number</h2> <span>{hiddenCardNumber(`${token?.bin}xxxxxx${token?.card_details?.last_four_digits}`)}</span>
                        </div>
                        <div className='detail-value'>
                          <h2>Card Type</h2>
                          <span>
                            <img width={25} alt={token?.card_details?.card_network} src={`https://js.xstak.com/images/${token?.card_details?.card_network?.toLowerCase()}.svg`} />
                          </span>
                        </div>
                      </Fragment>
                    </div>
                  ))}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
